module.exports = "/_next/static/images/9fd36e272155a598b2044b30cee32d85-mulher-com-cachos-maravilhosos-segurando-cartao-xs@3x.jpg";